import { inject, Injectable } from '@angular/core';
import { AppearanceStrategyFactoryService } from './appearance-strategy-factory.service';
import { Branding, BrandingAccess } from '@rx-applications/shared/branding/utils';

@Injectable({
  providedIn: 'root',
})
export class BrandingManagerService {
  readonly #appearanceStrategyFactory = inject(AppearanceStrategyFactoryService);

  #branding: Branding | null = null;
  setBranding(branding: Branding) {
    this.#branding = branding;
  }

  getBrandAccess(): BrandingAccess {
    if (!this.#branding) {
      throw new Error(`Branding not set: ${this.#branding}`);
    }
    return this.#appearanceStrategyFactory.getAppearance(this.#branding);
  }
}
